import React, { useState } from 'react';
import axios from 'axios';

const BulkReport = () => {
  const [file, setFile] = useState(null);
  const [data, setData] = useState([]);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleFileUpload = async () => {
    const formData = new FormData();
    formData.append('file', file);
  
    try {
      const response = await axios.post('http://35.159.43.224:3070/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('Response from backend:', response.data);
  
      if (response.data.length > 0) {
        const formattedData = response.data.map(item => ({
          Bezeichnung: extractBezeichnung(item.Bezeichnung),
          EPreis: extractEPreis(item.EPreis),
        }));
        setData(formattedData);
      } else {
        console.log('Received empty data from backend');
        // Optionally display a message to the user about the empty response
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      // Optionally display an error message to the user
    }
  };
  
  const extractBezeichnung = (original) => {
    // Extract and truncate the number part after "Auftrag Nr: "
    const match = original.match(/Auftrag Nr: (\d+-\d+)/);
    return match ? match[1] : original;
  };

  const extractEPreis = (original) => {
    // Remove " €" and any additional spaces
    return original.replace(/[€\s]/g, '');
  };

  return (
    <div>
      <input type="file" onChange={handleFileChange} />
      <button onClick={handleFileUpload}>Upload</button>
      {data.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Bezeichnung</th>
              <th>E-Preis €</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{item.Bezeichnung}</td>
                <td>{item.EPreis}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BulkReport;
